/**
 * 导入所有图片并抛出图片集合
 * 
 */

const images = require.context('../image', false, /\.jpg|.png$/)
const modules = {}
images.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.jpg|.png)/g, '')] = images(key)
})

export default modules